import { noop } from 'lodash';
import React, { useContext, useState } from 'react';
import type { ToolbarContextType } from 'ricos-context';
import { ModalContext, withToolbarContext } from 'ricos-context';
import { Decoration_Type } from 'ricos-schema';
import { decorateComponentWithProps } from 'wix-rich-content-editor-common';

import { ToolbarButton } from '../ToolbarButton';

const getColorButton = ({
  toolbarItem,
  context,
  dataHook,
  modalId,
}: {
  toolbarItem?: any;
  context: ToolbarContextType;
  dataHook?: string;
  modalId: string;
}) => {
  if (!context) return null;
  const { isMobile, t, getEditorCommands } = context;
  const modalService = useContext(ModalContext);
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);
  const editorCommands = getEditorCommands();
  const Icon = toolbarItem.presentation.getIcon(editorCommands);
  const tooltip = t(toolbarItem.presentation?.tooltip);

  const onClick = () => {
    const isModalOpen = modalService.isModalOpen(modalId);

    isModalOpen
      ? modalService.closeModal(modalId)
      : modalService.openModal(modalId, {
          componentProps: { referenceElement },
          positioning: { placement: 'bottom', referenceElement },
          layout: isMobile ? 'drawer' : 'popover',
          noPadding: true,
          /* onClickOutside is handled in TextColorPicker component */
          onClickOutside: noop,
        });
  };

  return (
    <ToolbarButton
      ref={setReferenceElement}
      disabled={toolbarItem.attributes.disabled}
      isMobile={isMobile}
      tooltip={tooltip}
      onClick={onClick}
      icon={() => <Icon />}
      dataHook={dataHook}
    />
  );
};

export const TextColorButton = withToolbarContext(
  decorateComponentWithProps(getColorButton, {
    modalId: `${Decoration_Type.COLOR}.foreground.picker`,
  })
);
export const HighlightColorButton = withToolbarContext(
  decorateComponentWithProps(getColorButton, {
    modalId: `${Decoration_Type.COLOR}.background.picker`,
  })
);
